module.exports = __webpack_public_path__ + "static/media/NewTestament_desc.22692295.png";